import { XIcon } from '@heroicons/react/outline';
import { Input, Modal } from 'antd';
import Image from 'next/image';
import React from 'react';
import { useRecoilState } from 'recoil';

import { ZebraLearnLogo } from '../../../../../assets';
import PasswordIcon from '../../../../../assets/Icons/password';
import { authModalControl } from '../../../../atoms/authModalControl';
import ButtonDefault, { ButtonVariants } from '../../../shared/basic/button';
import { ShouldRender } from '../../../shared/basic/ShouldRender';

interface ModalComponentProps {
  visible: boolean;
  onCancel: () => void;
  isClosable?: boolean;
  errorsPassword: { password: string };
  setFormDataPassword: any;
  formDataPassword: { password: string };
  handlePhoneWithPassword: any;
  loading: boolean;
}

const PhonePasswordModal: React.FC<ModalComponentProps> = ({
  visible,
  onCancel,
  isClosable = true,
  errorsPassword,
  setFormDataPassword,
  formDataPassword,
  handlePhoneWithPassword,
  loading,
}) => {
  const [, setVisible] = useRecoilState(authModalControl);

  const handleClose = () => {
    onCancel();
    setFormDataPassword({
      password: '',
    });
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;

    setFormDataPassword({
      ...formDataPassword,
      [name]: value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await handlePhoneWithPassword();
  };

  return (
    <Modal
      title=''
      open={visible}
      centered={true}
      closable={false}
      onCancel={handleClose}
      footer={false}
      className='customLoginModal bg-bgColor bg-opacity-70 pt-5 px-10 rounded-2xl border-2 border-borderDarkGray backdrop-filter backdrop-blur-md'
    >
      <div className='flex items-center gap-y-10 flex-col justify-center'>
        <div className='z-30 flex flex-col gap-y-1 w-full'>
          <div className='relative pt-4'>
            <span className='flex justify-center w-full'>
              <Image
                src={ZebraLearnLogo}
                alt='Logo'
                priority
                className='object-contain h-3.5 w-full'
              />
            </span>
            <ShouldRender check={isClosable}>
              <span
                onClick={handleClose}
                className='absolute right-0 top-[40%] cursor-pointer'
              >
                <XIcon className='w-6 h-6 text-fadedWhite' />
              </span>
            </ShouldRender>
          </div>
          <div className='border-b-2 border-backgroundGray py-3' />
          <div className='flex items-center gap-y-10 flex-col justify-center'>
            <div className='z-30 py-6 flex flex-col w-full gap-y-1'>
              <h1 className='text-xl text-fadedWhite font-medium mt-1 leading-10 text-center w-full'>
                Enter your <b className='text-primary font-medium'>Password</b>
              </h1>
              <span className='text-textGray text-center text-base'>
                Please enter your password to confirm your identity before
                making changes
              </span>
              <form
                onSubmit={handleSubmit}
                className='flex flex-col gap-2 mt-4 w-full'
              >
                <Input.Password
                  type='password'
                  name='password'
                  autoFocus={false}
                  style={{
                    backgroundColor: '#000000',
                  }}
                  placeholder='Password'
                  value={formDataPassword.password}
                  prefix={
                    <span className='pr-2'>
                      <PasswordIcon />
                    </span>
                  }
                  onChange={handleChange}
                  size='large'
                  className='border text-sm focus-within:bg-bgColor placeholder:text-textDarkGrayColor rounded-xl border-bgDarkGray py-2 text-white bg-bgColor customInputBlack makeBgBlack'
                  autoComplete='current-password'
                />
                {errorsPassword.password && (
                  <p className='text-red-500'>{errorsPassword.password}</p>
                )}
                <span
                  onClick={() => {
                    setVisible((prevState) => ({
                      ...prevState,
                      login: false,
                      signUp: false,
                      forgotPassword: true,
                    }));
                    handleClose();
                  }}
                  className='font-medium text-primary mt-1 cursor-pointer hover:text-darkPrimary'
                >
                  Forgot password?
                </span>

                <span className='flex justify-center mt-2'>
                  <ButtonDefault
                    size={4}
                    variant={ButtonVariants.WHITE}
                    className='p-1 w-full'
                    enableScaling={false}
                    rounded={true}
                    loading={loading}
                    onClick={handleSubmit}
                  >
                    <span className='flex text-sm font-bold gap-x-2 px-4 py-1 whitespace-nowrap'>
                      Update
                    </span>
                  </ButtonDefault>
                </span>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PhonePasswordModal;
